import React from 'react'

import { AdobeTargetProvider } from '@fs/zion-adobe-target'
import { FeatureFlagsProvider } from '@fs/zion-flags'

export default function FrontierBaseProviders({ flagOptions, mockFlags, mockActivities, children }) {
  return (
    <FeatureFlagsProvider {...flagOptions} mockFlags={mockFlags}>
      <AdobeTargetProvider mockActivities={mockActivities}>{children}</AdobeTargetProvider>
    </FeatureFlagsProvider>
  )
}
